const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function fetchImage(url, language, options = {}) {
  try {
    const queryParams = new URLSearchParams({
      language,
      ...options
    }).toString();
    const response = await fetch(`${backendUrl}/${url}?${queryParams}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error('Failed to fetch data:', error);
    throw error;
  }
}

export async function fetchData(url, language, options = {}) {
  try {
    const queryParams = new URLSearchParams({
      language,
      ...options
    }).toString();
    const response = await fetch(`${backendUrl}/${url}?${queryParams}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch data:', error);
    throw error;
  }
}

export async function postData(url = '', data = {}, language, options = {}) {
  console.log(data);
  const queryParams = new URLSearchParams({
      language,
      ...options
    }).toString();
  const response = await fetch(`${backendUrl}/${url}?${queryParams}`, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    headers: {
      'Content-Type': 'application/json', // 'Content-Type': 'application/x-www-form-urlencoded' for form data
      'Authorization': `Bearer ${localStorage.getItem("token")}`
    },
    body: JSON.stringify(data)
  });

  return response.json();
}

export async function putData(url = '', data = {}, language, options = {}) {
  const queryParams = new URLSearchParams({
      language,
      ...options
    }).toString();
  const response = await fetch(`${backendUrl}/${url}?${queryParams}`, {
    method: 'PUT', // *GET, POST, PUT, DELETE, etc.
    headers: {
      'Content-Type': 'application/json', // 'Content-Type': 'application/x-www-form-urlencoded' for form data
      'Authorization': `Bearer ${localStorage.getItem("token")}`
    },
    body: JSON.stringify(data)
  });

  return response.json();
}

export async function deleteData(url = '', language, options = {}) {
  const queryParams = new URLSearchParams({
    language,
    ...options
  }).toString();

  const response = await fetch(`${backendUrl}/${url}?${queryParams}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem("token")}`
    }
  });

  if (!response.ok) {
    const error = new Error(response.status === 405 ? "Unauthorized.": "Delete request failed.");
    error.status = response.status;
    throw error;
  }

  return response.json();
}
